import { render, staticRenderFns } from "./ParcelDetailsNotFoundDialog.vue?vue&type=template&id=32cb0b44"
import script from "./ParcelDetailsNotFoundDialog.vue?vue&type=script&lang=js"
export * from "./ParcelDetailsNotFoundDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports